import { Check, X } from "lucide-react";

function Decision({ value, onYes, onNo, locked, id }) {
  return (
    <div className="flex gap-1 shrink-0">
      <button data-testid={`${id}-approve`} disabled={locked} onClick={onYes}
        className={`px-2 py-1 rounded text-xs inline-flex items-center gap-1 border ${value === true ? "bg-emerald-600/20 border-emerald-500/50 text-emerald-300" : "border-border text-slate-400 hover:text-emerald-300"}`}><Check size={11} />Approve</button>
      <button data-testid={`${id}-reject`} disabled={locked} onClick={onNo}
        className={`px-2 py-1 rounded text-xs inline-flex items-center gap-1 border ${value === false ? "bg-rose-600/20 border-rose-500/50 text-rose-300" : "border-border text-slate-400 hover:text-rose-300"}`}><X size={11} />Reject</button>
    </div>
  );
}

export default function ReviewItems({ c, onDecide, locked }) {
  const a = c.approvals || {};
  return (
    <div className="card-surface space-y-3" data-testid="draft-review-items">
      <div className="label-xs">Staff approvals needed</div>
      <div className="flex items-center gap-3 text-sm">
        <div className="flex-1"><span className="text-slate-500 text-xs mr-2">Work authorization (confirm wording with client)</span>{c.work_authorization}</div>
        <Decision id="approve-work-auth" locked={locked} value={a.work_authorization ?? null} onYes={() => onDecide("work_authorization", 0, true)} onNo={() => onDecide("work_authorization", 0, false)} />
      </div>
      {c.currency_conversions.map((x, i) => (
        <div key={i} className="flex items-center gap-3 text-sm">
          <div className="flex-1"><span className="text-slate-500 text-xs mr-2">Currency</span>{x.original} → <b>{x.suggested_usd}</b> <span className="text-xs text-slate-500">({x.where})</span></div>
          <Decision id={`conversion-${i}`} locked={locked} value={a.currency_conversions?.[i]} onYes={() => onDecide("currency_conversions", i, true)} onNo={() => onDecide("currency_conversions", i, false)} />
        </div>
      ))}
      {c.gap_framings.map((x, i) => (
        <div key={i} className="flex items-center gap-3 text-sm">
          <div className="flex-1"><span className="text-slate-500 text-xs mr-2">Gap: {x.gap}</span>{x.suggestion}</div>
          <Decision id={`gap-framing-${i}`} locked={locked} value={a.gap_framings?.[i]} onYes={() => onDecide("gap_framings", i, true)} onNo={() => onDecide("gap_framings", i, false)} />
        </div>
      ))}
      {!c.currency_conversions.length && !c.gap_framings.length && <div className="text-xs text-muted-foreground">No currency conversions or gaps over 3 months found.</div>}
      <div className="text-[11px] text-muted-foreground">Rejected conversions mean you must edit the affected bullet by hand.</div>
    </div>
  );
}
